import {Dimensions, DimensionValue, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';

const VIEWPORT_HEIGHT: DimensionValue = '100vh' as DimensionValue;
import {MAX_CONTENT_WIDTH} from '/constant/data.constant';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
    height: VIEWPORT_HEIGHT,
    maxHeight: VIEWPORT_HEIGHT,
    overflow: 'hidden' as const,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
  },
  content: {
    flex: 1,
    backgroundColor: white,
    overflow: 'scroll' as const,
  },
  tabLayout: {
    width: Dimensions.get('window').width - 38,
    alignSelf: 'center',
    flex: 0,
    marginHorizontal: 20,
  },
  contentLoading: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white,
  },
  sections: {
    paddingBottom: 60,
  },
  taskDetailsTitle: {
    fontSize: 16,
    marginTop: indent * 0.1,
    alignSelf: 'flex-start',
  },
  taskDetailsIconLeft: {
    marginRight: indent * 0.3,
  },
  taskDetailsIconsGap: {
    alignItems: 'flex-start',
  },
});
